import { ButtonIcon } from "@fpsoftware/mvp";
import { TbEdit } from "react-icons/tb";
import styles from "./EditableValue.module.css";

interface EditableValuesProps {
  onEdit: () => unknown;
  label: string;
  sublabel?: string;
}

export function EditableValue(props: EditableValuesProps) {
  return (
    <div className={styles.container}>
      <ButtonIcon icon={TbEdit} onClick={props.onEdit} />
      <div>
        <div>{props.label}</div>

        {props.sublabel && <small>{props.sublabel}</small>}
      </div>
    </div>
  );
}
